import AboutClub from "./AboutClub";
import Currency from "./Currency";
import ChallengesInfo from "./ChallengesInfo";
import ChallengeTypes from "./ChallengeTypes";
import DailyAchievements from "./DailyAchievements";
import ParentsStats from "../ParentsStats";

// Единый источник для страниц раздела "Для родителей":
// используется и для роутов в App.jsx, и для пунктов меню в UserLinks.js
export const parentsRoutes = [
    { label: "Наш клуб", path: "/parents/about/", Component: AboutClub },
    { label: "Звания", path: "/parents/ranks/", Component: Currency },
    { label: "О Челленджах", path: "/parents/challenges/", Component: ChallengesInfo },
    { label: "Типы Челленджей", path: "/parents/challenge-types/", Component: ChallengeTypes },
    { label: "Ежедневные ачивки", path: "/parents/daily/", Component: DailyAchievements },
    { label: "Статистика", path: "/parents/stats/", Component: ParentsStats },
];
